/**
 * @flow
 */
import {EgretLoadable} from "../../../egret";
import {ROUTE} from '../../settings';

const logsRoutes = [
  {path: ROUTE.LOGS_BAD_DATA, component: EgretLoadable({loader: () => import("./LogsBadData")})},
  {path: ROUTE.LOGS_ACTIVITIES, component: EgretLoadable({loader: () => import("./LogsActivities")})},
  {path: ROUTE.LOGS_NOTIFICATIONS, component: EgretLoadable({loader: () => import("./LogsNotifications")})},
  {path: ROUTE.LOGS_LOGINS, component: EgretLoadable({loader: () => import("./LogsLogins")})},
  {path: ROUTE.LOGS_ERRORS, component: EgretLoadable({loader: () => import("./LogsErrors")})},
  {path: ROUTE.LOGS_DEMO_REQUESTS, component: EgretLoadable({loader: () => import("./LogsDemoRequests")})},
];

export default logsRoutes;
